import type { z } from "zod";

import { zOutSchema } from "./common";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(200, zOutSchema);
const zRes4xx = Response.Schema.zUnsuccessful2([400, 401]);

const zRes = Response.Schema.zAggregated([zRes200, ...zRes4xx]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
